
// This file is generated. Don't modify it.
import React from 'react'
export default function UnFolderIcon (props) {

    const { color } = props
    
    return (
                
        <svg width="1em" height="1em" viewBox="0 0 16 16">
            <defs>
                <path d="M7.99972936,2.8 C5.12793867,2.8 2.8,5.12808375 2.8,7.99972936 C2.8,10.8718437 5.12786613,13.2 7.99972936,13.2 C10.8717181,13.2 13.2,10.8717181 13.2,7.99972936 C13.2,5.1280112 10.8719888,2.8 7.99972936,2.8 Z M7.99972936,2 C11.3140872,2 14,4.68645405 14,7.99972936 C14,11.3135459 11.3135459,14 7.99972936,14 C4.68591277,14 2,11.3135459 2,7.99972936 C2,4.68645407 4.68591277,2 7.99972936,2 Z M7.43433061,6.09092901 L7.43314576,6.08977623 L7.99883119,5.52409081 L8,5.52525962 L8.00116881,5.52409081 L8.56685424,6.08977623 L8.56566279,6.09092241 L10.8272583,8.35251793 L9.75881665,8.35251793 L7.99679598,6.63817491 L6.21474317,8.35251793 L5.17274169,8.35251793 L7.43433061,6.09092901 Z M7.99679598,8.83752092 L9.75881665,10.5518639 L10.8272583,10.5518639 L8.56566279,8.29026842 L8.56685424,8.28912224 L8.00116881,7.72343682 L8,7.72460563 L7.99883119,7.72343682 L7.43314576,8.28912224 L7.43433061,8.29027502 L5.17274169,10.5518639 L6.21474317,10.5518639 L7.99679598,8.83752092 Z" id="UnFolderIcon-path-1"></path>
            </defs>
            <g id="Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Iconology" transform="translate(-552.000000, -124.000000)">
                    <g id="Icon" transform="translate(48.000000, 124.000000)">
                        <g id="Icon/Unfolder" transform="translate(504.000000, 0.000000)">
                            <g id="Group-3">
                                <rect id="16px-Bounding-Box" stroke="none" fill="none" fillRule="nonzero" x="0.5" y="0.5" width="15" height="15"></rect>
                                <mask id="UnFolderIcon-mask-2" fill="white">
                                    <use href="#UnFolderIcon-path-1"></use>
                                </mask>
                                <use id="Combined-Shape" fill={color} fillRule="nonzero" href="#UnFolderIcon-path-1"></use>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}
